
import React from 'react';
import { Product } from '@/types/portfolio';
import { ProductCard } from '@/components/portfolio/ProductCard';
import { ProductsTableView } from '@/components/portfolio/ProductsTableView';

interface ProductsListProps {
  products: Product[];
  onDelete: (id: string) => void;
  onEdit: (product: Product) => void;
  view?: 'card' | 'table';
}

export const ProductsList = ({ products, onDelete, onEdit, view = 'card' }: ProductsListProps) => {
  if (view === 'table') {
    return (
      <ProductsTableView 
        products={products}
        onDelete={onDelete}
        onEdit={onEdit}
      />
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      ))}
    </div>
  );
};
